export default ({ condition, trueWrapper, falseWrapper, children }) => {
  if (condition) {
    return trueWrapper(children)
  }

  return falseWrapper(children)
}
